// src/components/ServiceSection.js

import React, { useEffect, useState, useRef } from "react";
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
const serviceData = [
  {
    icon: "🏠",
    title: "HỆ THỐNG ĐIỀU HOÀ DÂN DỤNG",
    description:
      "Cung cấp và lắp đặt các loại máy lạnh dân dụng, đảm bảo không gian mát mẻ và tiện nghi.",
  },
  {
    icon: "🏢",
    title: "HỆ THỐNG ĐIỀU HOÀ TRUNG TÂM",
    description:
      "Thiết kế, thi công các hệ thống điều hòa lớn (VRV, Chiller) cho cao ốc văn phòng, trung tâm thương mại.",
  },
  {
    icon: "💨",
    title: "HỆ THỐNG THÔNG GIÓ",
    description:
      "Giải pháp thông gió, hút mùi, xử lý không khí cho nhà bếp công nghiệp, tầng hầm và khu vực sản xuất.",
  },
  {
    icon: "💧⚡",
    title: "HỆ THỐNG ĐIỆN NƯỚC",
    description:
      "Lắp đặt đường ống cấp thoát nước, hệ thống điện chiếu sáng, điện nhẹ và phân phối điện an toàn.",
  },
  {
    icon: "🔥",
    title: "HÀN CƠ KHÍ",
    description:
      " Gia công, lắp đặt kết cấu thép, ống dẫn công nghiệp, giá đỡ chuyên dụng với kỹ thuật hàn tiêu chuẩn cao.",
  },
  {
    icon: "🧱",
    title: "THỢ NỀ",
    description:
      " Cung cấp dịch vụ hoàn thiện xây dựng, xử lý các hạng mục nề cơ bản và chuyên sâu đi kèm hệ thống M&E.",
  },
];

// *** Hook tùy chỉnh để phát hiện phần tử xuất hiện ***
const ServiceSection = () => {
  // *** 1. Tạo Ref cho mỗi Card ***

  // Chúng ta không thể dùng useOnScreen cho từng card, nên sẽ dùng cho cả section

  // Phát hiện cả section
  const getRevealClass = (isVisible) =>
    `service-card scroll-reveal-item ${isVisible ? "is-visible" : ""}`;
  return (
    <section className="service-section">
      {}
      <h3 className="service__subtitle">DỊCH VỤ CỦA CHÚNG TÔI</h3>

      <div className="service__grid" x>
        {serviceData.map((service, index) => {
          // *** 2. Xác định hướng chuyển động cho từng hàng (index) ***
          // Hàng 1 (index 0, 1, 2) là Chạy vào từ TRÁI
          // Hàng 2 (index 3, 4, 5) là Chạy vào từ PHẢI
          // Hàng 3 (index 6, 7, 8) là Chạy vào từ TRÁI
          const row = Math.floor(index / 3);
          const directionClass = row % 2 === 0 ? "from-left" : "from-right";
          // Tạo một Hook cho mỗi thẻ
          const [cardRef, isCardVisible] = useScrollReveal({ threshold: 0.3 });
          return (
            <div
              key={index}
              // Dùng class chung 'fade-in-slide'
              className={`service__card ${getRevealClass(isCardVisible)}`}
              ref={cardRef}
              style={{ "--reveal-delay": `${index * 0.1}s` }}
            >
              <div className="service__icon">{service.icon}</div>
              <h4 className="service__title">{service.title}</h4>
              <p className="service__description">{service.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default ServiceSection;
